var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.667 13.333q.566 0 .95-.384T12 12q0-.567-.384-.95a1.29 1.29 0 0 0-.95-.383q-.566 0-.95.384a1.29 1.29 0 0 0-.383.949q0 .567.384.95.384.385.95.383M5.333 24v-2.667l8-1.333V5.167q0-.501-.3-.9a1.13 1.13 0 0 0-.766-.467L5.333 2.667V0l7.334 1.2q1.466.266 2.4 1.367T16 5.133V22.2zM0 24v-2.667h2.667V2.667q0-1.134.784-1.9A2.6 2.6 0 0 1 5.333 0h13.334q1.133 0 1.9.767.766.765.766 1.9v18.666H24V24zm5.333-2.667h13.334V2.667H5.333z"
  })));
};
export default SvgLogout;